// The map legend's memory (issue #39): dismissed once, hidden on this device. Storage that is missing or throws
// (private mode, blocked site data) never breaks the map: the legend simply shows again.

export const MAP_LEGEND_KEY = 'aurane.mapLegend';
type Store = Pick<Storage, 'getItem' | 'setItem'>;
const store = (): Store | null => { try { return localStorage; } catch { return null; } };

export function legendHidden(s: Store | null = store()): boolean {
  try { return s?.getItem(MAP_LEGEND_KEY) === 'hidden'; } catch { return false; }
}

export function hideLegend(s: Store | null = store()): void {
  try { s?.setItem(MAP_LEGEND_KEY, 'hidden'); } catch { /* the legend comes back next visit */ }
}
